export const formatDagVersionLabel = (version?: number | string | null): string => {
  if (version == null) {
    return '-';
  }

  const versionText = String(version).trim();
  if (!versionText) {
    return '-';
  }

  const numericVersion = Number(versionText);
  if (!Number.isFinite(numericVersion)) {
    return versionText;
  }

  return numericVersion.toFixed(1);
};
